<template>
    <div>
        <div style="padding-bottom:10px;display: flex;transition: .25s;" :style="{'height':height+50+'px'}">
            <div class="sp-card" style="flex:14">
                <div id="cus4" style="width:100%;height:100%">
                </div>
            </div>
            <div style="width:10px"></div>
            <div style="padding-top:50px;flex:21">
                <div class="sp-card" id="spc" :style="{'height':height+'px'}">
                    <div id="cus3" style="width:100%;height:100%"></div>
                    <div class="rate" v-if="lastMonthAdd">
                        <div>
                            <span class="imp">{{ lastMonthAdd }}</span>
                            <span class="normal">%</span>
                        </div>
                        <div class="normal">同比上月</div>
                    </div>
                </div>
            </div>
            <div style="width:10px"></div>
            <div style="flex:16;display: flex;flex-direction: column;">
                <div class="right-area" style="flex:6;">
                    <div class="sp-card">
                        <div id="cus1" style="width:100%;height:100%"></div>
                    </div>
                    <div class="sp-card">
                        <div id="cus2" style="width:100%;height:100%"></div>
                    </div>
                </div>
                <div style="height:10px"></div>
                <div class="sp-card" style="flex:7">
                    <div id="cus5" style="width:100%;height:100%"></div>
                </div>
            </div>
        </div>
        <div class="grid-box-sc" :style="{'height':scheight+'px'}">
            <div class="sp-card">
                <div id="cus6" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="cus7" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="cus8" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card" id="scspc">
                <div id="cus9" style="width:100%;height:100%"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
        filterbox:{
            type:Object,
            default:()=>{
                return {};
            }
        }
    },
    data(){
        return{
            chartList:[null,null,null,null,null,null,null,null,null],
            isShowPage:false,
            height:0,
            scheight:0,
            lastMonthAdd:0,
        }
    },
    methods:{
        checkHeight:function(){
            let width = document.getElementById('spc').clientWidth;
            this.height = Math.floor(width/6*5);
            if(this.height>500){
                this.height = 400;
            }
            let scwidth = document.getElementById('scspc').clientWidth;
            this.scheight = Math.floor(scwidth);
            if(this.scheight>500){
                this.scheight = 400;
            }
            let windowheight = window.innerHeight;
            if(this.height+this.scheight>windowheight){
                this.height = Math.floor(windowheight*0.6)
                this.scheight = Math.floor(windowheight*0.3)
            }
        },
        setResize:function(){
            this.checkHeight();
            this.chartList.forEach(e=>{
                if(e){e.resize();}
            })
        },
        init:function(){
            this.$nextTick(()=>{
                this.checkHeight();
                this.isShowPage = true;
                setTimeout(()=>{
                    this.getInfo();
                    this.getInfo2();
                },250)
            })
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('cus'+(key+1)))
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getInfo:function(){
            let dd = new Date();
            let today = this.$common.dayformat(dd);
            let week = dd.getDay()?dd.getDay():7;
            let start = this.$common.dayformat(new Date(dd.getTime()-(week-1)*24*60*60*1000));
            let end = this.$common.dayformat(new Date(dd.getTime()-(week-7)*24*60*60*1000));
            this.$api.customerlistCustomer({limit:1,page:1,start:start,end:end}).then(res=>{
                let total = res.data.count;
                let max = Math.ceil(total/8)*10;
                if(max<10){
                    max = 10;
                }
                let myChart = this.getMyChart(0);
                if(myChart){
                    let option = {
                        title:{
                            text:'本周新增',
                            left:'left',
                        },
                        series: [
                            {
                                startAngle: 140,
                                endAngle: 40,
                                center: ['50%', '80%'],
                                min: 0,
                                max: max,
                                type: 'gauge',
                                splitNumber:2,
                                itemStyle:{
                                    color:{
                                        colorStops: [{
                                            offset: 0, color: '#0380F8' // 0% 处的颜色
                                        }, {
                                            offset: 1, color: '#16EEFF' // 100% 处的颜色
                                        }],
                                    },
                                },
                                progress: {
                                    show: true,
                                    width: 20
                                },
                                axisLine: {
                                    lineStyle: {
                                    width: 20
                                    }
                                },
                                pointer:{
                                    show:false,
                                },
                                axisTick:{
                                show:false,
                                },
                                splitLine:{
                                show: false,
                                },
                                axisLabel: {
                                    distance: -40,
                                    color: '#999',
                                    fontSize: 10
                                },
                                title: {
                                    show: true,
                                },
                                detail: {
                                    valueAnimation: true,
                                    fontSize: 18,
                                    offsetCenter: [0, '0%']
                                },
                                data: [
                                    {
                                    value: total,
                                    }
                                ]
                            }
                        ]
                    }
                    myChart.setOption(option);
                }
            })
            this.$api.customerlistCustomer({limit:1,page:1,start:today,end:today}).then(res=>{
                let total = res.data.count;
                let max = Math.ceil(total/8)*10;
                if(max<10){
                    max = 10;
                }
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = {
                        title:{
                            text:'本日新增',
                            left:'left',
                        },
                        series: [
                            {
                                startAngle: 140,
                                endAngle: 40,
                                center: ['50%', '80%'],
                                min: 0,
                                max: max,
                                type: 'gauge',
                                splitNumber:2,
                                itemStyle:{
                                    color:{
                                        colorStops: [{
                                            offset: 0, color: '#A625FC' // 0% 处的颜色
                                        }, {
                                            offset: 1, color: '#3AA4FA' // 100% 处的颜色
                                        }],
                                    },
                                },
                                progress: {
                                    show: true,
                                    width: 20
                                },
                                axisLine: {
                                    lineStyle: {
                                    width: 20
                                    }
                                },
                                pointer:{
                                    show:false,
                                },
                                axisTick:{
                                show:false,
                                },
                                splitLine:{
                                show: false,
                                },
                                axisLabel: {
                                    distance: -40,
                                    color: '#999',
                                    fontSize: 10
                                },
                                title: {
                                    show: true,
                                },
                                detail: {
                                    valueAnimation: true,
                                    fontSize: 18,
                                    offsetCenter: [0, '0%']
                                },
                                data: [
                                    {
                                    value: total,
                                    }
                                ]
                            }
                        ]
                    }
                    myChart.setOption(option);
                }
            })
            this.$api.customerlistCustomer({limit:1,page:1}).then(res=>{
                let total = res.data.count;
                let dd1 = new Date();
                dd1.setDate(1);
                let nowstart = this.$common.dayformat(dd1);
                if(total<0){
                    total = 0;
                }
                dd1.setMonth(dd1.getMonth()+1);
                let nowend = this.$common.dayformat(dd1);
                this.$api.customerlistCustomer({limit:1,page:1,start:nowstart,end:nowend}).then(res1=>{
                    let lt =total-res1.data.count;
                    if(lt==0){
                        this.lastMonthAdd = '0.00';
                    }else{
                        this.lastMonthAdd = (total*100/lt).toFixed(2);
                    }
                })
                let myChart = this.getMyChart(2);
                if(myChart){
                    let option = {
                        title:{
                            text:'客户数量总计',
                            left:'center',
                            top:'35%',
                        },
                        series: [
                            {
                                startAngle: 210,
                                endAngle: -30,
                                center: ['50%', '50%'],
                                min: 0,
                                max: total,
                                type: 'gauge',
                                splitNumber:6,
                                itemStyle:{
                                    color:{
                                        colorStops: [{
                                            offset: 0, color: '#A625FC' // 0% 处的颜色
                                        }, {
                                            offset: 1, color: '#3AA4FA' // 100% 处的颜色
                                        }],
                                    },
                                },
                                progress: {
                                    show: true,
                                    roundCap: true,
                                    width: 20,
                                },
                                axisLine: {
                                    roundCap: true,
                                    lineStyle: {
                                        width: 20,
                                    }
                                },
                                pointer:{
                                    show:false,
                                },
                                axisTick:{
                                    distance: -32,
                                    show:true,
                                },
                                splitLine:{
                                    distance: -35,
                                    show: true,
                                },
                                axisLabel: {
                                    show:false,
                                },
                                title: {
                                    show: true,
                                },
                                detail: {
                                    valueAnimation: true,
                                    fontSize: 38,
                                    offsetCenter: [0, '0%'],
                                },
                                data: [
                                    {
                                        value: total,
                                    }
                                ]
                            }
                        ]
                    }
                    myChart.setOption(option);
                }
            })
            let lstart = this.$common.dayformat(new Date(dd.getTime()-13*24*60*60*1000));
            this.$api.customerStatisticByDate({start:lstart,end:today}).then(res=>{
                let nowweek = res.data.data.data.map(e=>e.count);
                if(nowweek.length>14){
                    nowweek = nowweek.splice(0,14);
                }else if(nowweek.length<14){
                    let key = 14-nowweek.length;
                    while(key>0){
                        nowweek.push(0);
                        key--;
                    }
                }
                let lastweek = nowweek.splice(0,7);
                let temp = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
                let weekList = temp.splice(dd.getDay(),7);
                weekList.push(...temp);
                let myChart = this.getMyChart(4);
                if(myChart){
                    let option = {
                        title:{
                            text:'客户增长走势',
                            left:'left',
                        },
                        legend: {
                            left:'right',
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: weekList,
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                        { 
                            type: 'bar',
                            name:'本周',
                            data: nowweek,
                        },
                        {
                            data: lastweek,
                            type: 'line',
                            name:'上周',
                            smooth: true,
                            itemStyle: {
                                color: '#0380F8'
                            },
                            areaStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(16,238,255,1)'
                                },{
                                    offset: 1,
                                    color: 'rgba(16,238,255,0.2)'
                                }])
                            },
                        },
                        ]
                }
                    myChart.setOption(option);
                }
            })
        },
        getInfo2:function(){
            let obj = {};
            if(this.filterbox.time&&this.filterbox.time.length==2){
                obj.start = this.filterbox.time[0];
                obj.end = this.filterbox.time[1];
            }
            this.$api.customerStatistic({group:1,...obj}).then(res=>{
                let arr = [];
                res.data.data.data.forEach((e,index)=>{
                    if(index<10){
                        arr.unshift({
                            name:e.e_name,
                            count:e.countNum,
                        })
                    }
                })
                let myChart = this.getMyChart(3);
                if(myChart){
                    let option = {
                        title:{
                            text:'客户数量排行',
                            left:'left',
                        },
                        legend: {},
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '10%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            show:false,
                        },
                        yAxis: { 
                            type: 'category',
                            data:arr.map(e=>e.name),
                            axisLabel:{
                                formatter:function(value){
                                    var res = value;
                                    if(res.length>3){
                                        res = res.substring(0,2)+'...';
                                    }
                                    return res;
                                }
                            },
                        },
                        series: [
                            { type: 'bar',data:arr.map(e=>e.count)},
                        ]
                    };
                    myChart.setOption(option);
                }
            })
            this.$api.customerStatistic({group:2,...obj}).then(res=>{
                let arr = [];
                res.data.data.data.forEach(e=>{
                    arr.push({
                        value:e.countNum,
                        name:e.c_state,
                    });
                })
                let myChart = this.getMyChart(5);
                if(myChart){
                    let option = {
                        title:{
                            text:'客户状态',
                            left:'left',
                        },
                        tooltip: {
                            trigger: 'item',
                        },
                        
                        grid: {
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true
                        },
                        series: [
                            {
                                type: 'funnel',
                                left: '10%',
                                top: 40,
                                bottom: 10,
                                width: '80%',
                                // minSize: '10%',
                                maxSize: '100%',
                                // sort: 'none',
                                gap: 1,
                                label: {
                                    show: true,
                                    position: 'inside'
                                },
                                labelLine: {
                                    length: 10,
                                    lineStyle: {
                                    width: 1,
                                    type: 'solid'
                                    }
                                },
                                itemStyle: {
                                    borderColor: '#fff',
                                    borderWidth: 1
                                },
                                emphasis: {
                                    label: {
                                    fontSize: 20
                                    }
                                },
                                data: arr,
                            },
                        ]
                    }
                    myChart.setOption(option);
                }
            })
            this.$api.customerStatistic({group:3,...obj}).then(res=>{
                let arr = [];
                let dd = [];
                res.data.data.data.forEach(e=>{
                    arr.push(e.countNum);
                    dd.push(e.c_rank);
                })
                let myChart = this.getMyChart(6);
                if(myChart){
                    let option = {
                        title:{
                            text:'客户等级',
                            left:'left',
                        },
                        legend: {
                            left:'right',
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: dd,
                        },
                        yAxis: {
                            type: 'value'
                        },
                        series: [
                        { 
                            type: 'bar',
                            data: arr,
                            itemStyle:{
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: '#02FCCC'
                                },{
                                    offset: 1,
                                    color: '#2A83D3'
                                }]),
                            },
                            showBackground: true,
                            backgroundStyle: {
                                color: '#f0f0f0'
                            }
                        },
                        ]
                    }
                    myChart.setOption(option);
                }
            })
            this.$api.customerStatistic({group:4,...obj}).then(res=>{
                let arr = [];
                res.data.data.data.forEach(e=>{
                    let obj = {
                        name:e.c_hangye,
                        value:e.countNum,
                    }
                    arr.push(obj)
                })
                let myChart = this.getMyChart(7);
                if(myChart){
                    let option = {
                        title:{
                            text:'客户行业',
                            left:'left',
                        },
                        tooltip: {
                            trigger: 'item'
                        },
                        series: [{
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                show: true,
                                fontSize: 20,
                                fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data:arr,
                        }]
                    };
                    myChart.setOption(option);
                }
            })
            this.$api.customerStatistic({group:5,...obj}).then(res=>{
                let arr = [];
                res.data.data.data.forEach(e=>{
                    let obj = {
                        name:e.c_laiyuan,
                        value:e.countNum,
                    }
                    arr.push(obj)
                })
                let myChart = this.getMyChart(8);
                if(myChart){
                    let option = {
                        title:{
                            text:'客户来源',
                            left:'left',
                        },
                        tooltip: {
                            trigger: 'item'
                        },
                        series: [{
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                show: true,
                                fontSize: 20,
                                fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data:arr,
                        }]
                    };
                    myChart.setOption(option);
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.grid-box-sc{
    display: grid;
    grid-template-columns: 3fr 3fr 2fr 2fr;
    grid-gap: 10px;
    transition: .25s;
}
.right-area{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
}
.rate{
    position: absolute;
    top: 62.5%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    text-align: center;
    .imp{
        color: #94ED77;
        font-size: 24px;
        font-weight: bold;
    }
    .normal{
        font-size: 12px;
        color: #999;
    }
}
</style>